module.exports = __webpack_public_path__ + "static/media/jonathanBorowka.4c447d51.png";